"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HighchartsRandomChartGenerator = exports.analyzeSeriesZones = exports.analyzeSeriesDataIncompleteMarkers = exports.analyzeSeriesDataAvailabilityStateMarkers = exports.numberFormat = exports.getExportFilename = exports.INCOMPLETE_HIGHCHARTS_MARKER = exports.getIncompleteHighchartsMarker = exports.getSeriesColorFromGlobalColors = exports.HighchartsCalculationsCommonUtils = void 0;
const highcharts_1 = __importDefault(require("highcharts"));
const DateTimeFacade_1 = require("src/hello_assets/src/util/DateTimeFacade");
const lodash_1 = __importDefault(require("lodash"));
const DECIMAL_SEPARATOR = .1.toLocaleString().substr(1, 1);
exports.HighchartsCalculationsCommonUtils = {
    ChartSettings: {
        chartHeight: 432
    },
};
const getHighchartsGlobalColors = () => {
    const { colors } = highcharts_1.default.getOptions();
    return colors;
};
const getSeriesColorFromGlobalColors = (seriesIndex) => {
    const colors = getHighchartsGlobalColors();
    const colorsLength = colors.length;
    const color = colors[seriesIndex % colorsLength];
    // console.log(`optionsForChart: series[${seriesIndex}] color =`, color)
    return color;
};
exports.getSeriesColorFromGlobalColors = getSeriesColorFromGlobalColors;
const getIncompleteHighchartsMarker = (seriesIndex) => {
    return {
        enabled: true,
        symbol: 'circle',
        radius: 3,
        fillColor: 'white',
        lineColor: (0, exports.getSeriesColorFromGlobalColors)(seriesIndex),
        lineWidth: 1.5
    };
};
exports.getIncompleteHighchartsMarker = getIncompleteHighchartsMarker;
exports.INCOMPLETE_HIGHCHARTS_MARKER = (0, exports.getIncompleteHighchartsMarker)(0);
const getExportFilename = (title) => {
    //n_day_retention_03-21-2021
    const titleClean = title.replace(/\s+/g, '_').toLowerCase();
    const filenameDate = highcharts_1.default.dateFormat(DateTimeFacade_1.HighchartsDateFormatByFunctionality.Common.export.credits, new Date().getTime());
    const filename = `${titleClean}_${filenameDate}`;
    return filename;
};
exports.getExportFilename = getExportFilename;
/**
 * Format a number and return a string based on input settings
 * @param value The input number to format.
 * @param decimals The amount of decimals.
 * @return The formatted number with no thousands separator.
 */
const numberFormat = (value, decimals) => {
    return parseFloat(highcharts_1.default.numberFormat(value, decimals, DECIMAL_SEPARATOR, "")).toString();
};
exports.numberFormat = numberFormat;
/**
 * Method adds single points to series data when there is no data right before certain point and right after
 * Need to find a sequence: "noData" - "complete" - "noData"
 * Method mutates *seriesData* parameter
 * @param seriesData point objects
 * @param seriesDataAvailabilityStates data states
 */
const analyzeSeriesDataAvailabilityStateMarkers = (seriesData, seriesDataAvailabilityStates) => {
    lodash_1.default.each(seriesDataAvailabilityStates, (markerState, idx) => {
        if (seriesDataAvailabilityStates.length === 1) {
            const aState = seriesDataAvailabilityStates[idx];
            if (aState === "complete") {
                const aSeriesData = seriesData[idx];
                aSeriesData.marker = {
                    enabled: true,
                    symbol: "circle",
                    radius: 2
                };
            }
            return;
        }
        if (idx === seriesDataAvailabilityStates.length - 1) {
            const aState = seriesDataAvailabilityStates[idx - 1];
            const bState = seriesDataAvailabilityStates[idx];
            // console.log("aState", aState);
            // console.log("bState", bState);
            if (aState === "noData" && bState === "complete") {
                const bSeriesData = seriesData[idx];
                bSeriesData.marker = {
                    enabled: true,
                    symbol: "circle",
                    radius: 2
                };
            }
        }
        if (idx > 1) {
            const aState = seriesDataAvailabilityStates[idx - 2];
            const bState = seriesDataAvailabilityStates[idx - 1];
            const cState = markerState;
            if (aState === "noData" && bState === "complete" && cState === "noData") {
                const bSeriesData = seriesData[idx - 1];
                bSeriesData.marker = {
                    enabled: true,
                    symbol: "circle",
                    radius: 2
                };
            }
        }
        if (idx === 1) {
            const aState = seriesDataAvailabilityStates[idx - 1];
            const bState = seriesDataAvailabilityStates[idx];
            if (aState === "complete" && bState === "noData") {
                const aSeriesData = seriesData[idx - 1];
                aSeriesData.marker = {
                    enabled: true,
                    symbol: "circle",
                    radius: 2
                };
            }
        }
    });
};
exports.analyzeSeriesDataAvailabilityStateMarkers = analyzeSeriesDataAvailabilityStateMarkers;
const analyzeSeriesDataIncompleteMarkers = (seriesData, seriesDataAvailabilityStates, seriesTargetIndex) => {
    if (seriesData.length === seriesDataAvailabilityStates.length) {
        lodash_1.default.each(seriesData, (pointValue, idx) => {
            if (seriesDataAvailabilityStates[idx] === "incomplete") {
                pointValue.marker = {
                    ...(0, exports.getIncompleteHighchartsMarker)(seriesTargetIndex)
                };
            }
        });
    }
};
exports.analyzeSeriesDataIncompleteMarkers = analyzeSeriesDataIncompleteMarkers;
const analyzeSeriesZones = (zones) => {
    const result = [];
    let lastZone = undefined;
    lodash_1.default.each(zones, (zone, idx) => {
        if ((lastZone === null || lastZone === void 0 ? void 0 : lastZone.dashStyle) !== zone.dashStyle) {
            if (lastZone) {
                // if (!!process.env.IS_TEST_SERVER) {
                //     console.log(`analyzeSeriesZones[${idx}]: will add lastZone`, lastZone);
                // }
                result.push(lastZone);
            }
            if (zones.length === 1 || (zones.length > 1 && idx > 0)) {
                // if (!!process.env.IS_TEST_SERVER) {
                //     console.log(`analyzeSeriesZones[${idx}]: will add zone`, zone);
                // }
                result.push(zone);
            }
        }
        lastZone = zone;
    });
    // if (!!process.env.IS_TEST_SERVER) {
    //     console.log("analyzeSeriesZones: zones", zones);
    //     console.log("analyzeSeriesZones: result", result);
    // }
    return result;
    // return [
    //     {value: 1660608000000, dashStyle: 'Solid'},
    //     {value: 1660694400000, dashStyle: 'Dot'}
    // ] as Array<SeriesZonesOptionsObject>
};
exports.analyzeSeriesZones = analyzeSeriesZones;
////////////////////////////////////////////////
// Random
////////////////////////////////////////////////
// http://jsfiddle.net/3br796h8/
function randomNumber(minimum, maximum) {
    return Math.round(Math.random() * (maximum - minimum) + minimum);
}
const generateRandomData1 = (numberOfPoints, parameters) => {
    let y = parameters.startValue;
    const dataPoints = [];
    for (let i = 0; i < numberOfPoints; i += 1) {
        y += randomNumber(parameters.pointDiffRange.from, parameters.pointDiffRange.to);
        dataPoints.push(y);
    }
    if (parameters.makePositive) {
        return makePositive(dataPoints);
    }
    return dataPoints;
};
const generateRandomData2 = (numberOfPoints, parameters = {}) => {
    const dataPoints = [];
    let y;
    for (let x = 0; x < numberOfPoints; x++) {
        y = randomNumber(x, 100);
        const a = 1 + (parameters.r1 || 0);
        const b = numberOfPoints + (parameters.r2 || 0);
        const c = 3;
        const d = 10;
        y = a * Math.pow(x, parameters.r3 || 2) + randomNumber(-b * x / c, b * x / d);
        y = Math.abs(y) + (parameters.startValue || 0);
        dataPoints.push(y);
    }
    return dataPoints;
};
const makePositive = (dataPoints) => {
    const minValue = lodash_1.default.min(dataPoints) || 0;
    return lodash_1.default.map(dataPoints, v => v - minValue);
};
exports.HighchartsRandomChartGenerator = {
    random1: generateRandomData1,
    random2: generateRandomData2,
    makePositive: makePositive,
};
// console.log("generateRandomData: ", generateRandomData(288));
// console.log("generateRandomData: ", generateRandomData(288));
// console.log("generateRandomData: ", generateRandomData(288));
// console.log("generateRandomData: ", generateRandomData(288));
